export default __webpack_public_path__ + "static/media/productFormat.f6639f2b.xlsx";